module.exports = "<div uib-datepicker ng-model=calendarSelDate datepicker-options=calendar_options ng-change=setDate()> </div>";